import { useDialog } from "@hooks";
import React, { useEffect } from "react";
import {
  BookingSupportChecks,
  BookingSupportChecksInfoTooltip
} from "@bookings/BookingProfile/TimeReport/components/BookingSupportChecks";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  LinearProgress,
  Typography
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import Skeleton from "@material-ui/lab/Skeleton";
import { useBookingKit_GetChecksQuery } from "@graphql";

type Props = {
  bookingId: string;
};

export function BookingKitChecks({ bookingId }: Props) {
  const dialog = useDialog();

  const { data, loading, error, refetch } = useBookingKit_GetChecksQuery({
    variables: { bookingId },
    skip: !dialog.open, // only query when dialog is open
    fetchPolicy: "network-only" // ensures fresh data each time
  });

  useEffect(() => {
    if (dialog.open) {
      refetch(); // refetch on dialog open
    }
  }, [dialog.open]);

  return (
    <>
      <Button
        variant="outlined"
        onClick={() => dialog.onOpen()}
        endIcon={<BookingSupportChecksInfoTooltip />}
      >
        {locale.CheckControlBtn}
      </Button>

      <Dialog fullWidth maxWidth="md" open={dialog.open} onClose={dialog.onClose}>
        <DialogContent>
          <Typography variant="h3" style={{ marginBottom: 10 }}>
            {`Kontrollera om alla relevanta uppgifter matchar mellan formulären, tidrapporten, bokningsveckan, sammanställningen, Rese- och boendebekräftelserna och kundprofilen. Vi kontrollerar:`}
          </Typography>

          {loading && !data && (
            <Box display="flex" gridGap="5px" flexDirection="column">
              {Array.from({ length: 15 }).map((_, i) => (
                <Skeleton key={i} variant="rect" width="100%" height={31} />
              ))}
            </Box>
          )}

          {error && (
            <Typography color="error">
              {`Ett fel uppstod när data hämtades: ${error.message}`}
            </Typography>
          )}

          {data?.getChecksForBooking && (
            <BookingSupportChecks data={data.getChecksForBooking} />
          )}

          {loading && <LinearProgress />}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={dialog.onClose}>
            {locale.Close}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
